export const BASE_URL = process.env.VUE_APP_API_BASE_URL || "http://localhost:3000";

const TOKEN_KEY = "token";
const USER_KEY = "user";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getSessionUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY)) || null;
  } catch (e) {
    return null;
  }
}

export function saveSession(token, usuario) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify({ id: usuario.id, email: usuario.email }));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

/**
 * fetch hacia el backend con el JWT de la sesión.
 * Si el backend responde 401 (sesión expirada o usuario inactivo) se cierra la sesión y se envía al login.
 */
export async function apiFetch(url, options = {}) {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(url, { ...options, headers });
  if (res.status === 401 && token) {
    clearSession();
    window.location.assign("/auth/login");
  }
  return res;
}

/** Petición JSON al backend. Lanza el cuerpo de error ({ msg, code }) si la respuesta no es exitosa. */
export async function apiJson(method, path, data) {
  const res = await apiFetch(`${BASE_URL}/api${path}`, {
    method,
    headers: { "Content-Type": "application/json" },
    ...(data !== undefined && { body: JSON.stringify(data) }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw json;
  return json;
}
